import { configObject } from "src/awsconfig";
import { DRONESQUARE_BACKEND } from "src/domains/shared/constants/constants";

/**
 * main-api base URL (raw fetch 전용).
 * SSM 값에 trailing slash가 있어도 제거해 raw fetch 문자열 조합 시 "//" 중복을 방지한다.
 * Amplify API.get/post 경로는 라이브러리가 자동 정규화하므로 이 헬퍼 불필요.
 */
export const backendBaseUrl = (): string =>
  configObject[DRONESQUARE_BACKEND].replace(/\/+$/, "");

/**
 * annotation 리소스 base 경로 빌더.
 * measure·volume 등 annotation 하위 계산 엔드포인트가 공유하는 백엔드 라우팅 계약(SoT).
 * 라우트 규약이 바뀌면 이 한 곳만 고치면 된다.
 */
export const buildAnnotationBaseUrl = ({
  projectId,
  timeProjectId,
  annotationId,
}: {
  projectId: number;
  timeProjectId: number;
  annotationId: number;
}): string =>
  `${backendBaseUrl()}/calculation/projects/${projectId}` +
  `/time_projects/${timeProjectId}/annotations/${annotationId}`;
